import { turbine } from "neql"
import { useCallback } from "react"
import { TRAINING_CREATING_ID } from "../Models/API/QualifierModel"
import { useNeqlContextProvider } from "./useNeqlContextProvider"

const PAGE_SIZE = 50
export const useTestQualifiedWorkers = (
    trainingId?: string,
    hasAppPermission = false
): [
    turbine.PaginatedQualifiedWorker | undefined | null,
    boolean,
    () => Promise<unknown>,
    () => Promise<unknown>
] => {
    const clientContext = useNeqlContextProvider("turbine")
    const { data, refetch, fetchMore } =
        turbine.useFetchTestQualifiedWorkersQuery({
            variables: {
                testQualifiedWorkersPage: 0,
                testQualifiedWorkersSize: PAGE_SIZE,
                testQualifiedWorkersTrainingId: trainingId ?? ""
            },
            skip:
                !hasAppPermission ||
                trainingId === undefined ||
                trainingId === TRAINING_CREATING_ID,
            client: clientContext
        })

    const handleFetchMore = useCallback(
        () =>
            fetchMore({
                variables: {
                    testQualifiedWorkersPage:
                        (data?.testQualifiedWorkers?.number ?? 0) + 1
                }
            }),
        [data, fetchMore]
    )

    return [
        data?.testQualifiedWorkers,
        (data?.testQualifiedWorkers?.content?.length ?? 0) <
            (data?.testQualifiedWorkers?.total ?? 0),
        handleFetchMore,
        refetch
    ]
}
